// @ts-nocheck
import { useLazyQuery, useMutation } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  mergeAllDataIntoFormData,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  CREATE_CONNECTION_CENTER,
  DELETE_CONNECTION_CENTER,
  EDIT_CONNECTION_CENTER,
  GET_CONNECTIONCENTER_BYID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import useKeyDown from "../AddLoad/text";
import { ConnectionCenterFields } from "./AddConnectionCenter.config";

const AddConnectionCenter = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [GetConnectionByID] = useLazyQuery(GET_CONNECTIONCENTER_BYID, {
    fetchPolicy: "network-only",
  });
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Connection_Center?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState({});
  // eslint-disable-next-line
  const [formType, setFormType] = useState([]);
  const FormData = useSelector((store: any) => store.FormFieldData);
  const [CreatingData, { loading: ConnectionCenterCreation }] = useMutation(CREATE_CONNECTION_CENTER);
  const [EditingData, { loading: ConnectionCenterEdit }] = useMutation(EDIT_CONNECTION_CENTER);
  const [DeletingData, { loading: ConnectionCenterDeletion }] = useMutation(DELETE_CONNECTION_CENTER);
  const dispatch = useDispatch();
  const ConnectionCenterLoading =
    ConnectionCenterCreation || ConnectionCenterEdit || ConnectionCenterDeletion ? true : false;

  useEffect(() => {
    setalldata(FormData.fielddata);
    setFormType(FormData.typeOfForm);
  }, [FormData]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Connection_Center?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
      GetConnectionByID({
        variables: {
          id: fielddata?.id,
        },
      }).then(({ data }) => {
        let ConnectionMasterData = { ...data?.getConnectionCenterMasterByID };
        setAllFieldsData(ConnectionMasterData);
      });
    } else {
      setAllFieldsData({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = mergeAllDataIntoFormData(alldata);
  const variables = usePrepareGraphQLVariables(
    operationType,
    allFieldsData,
    formData,
    selectedRows,
    "connectionCenterMasterInput",
    "input"
  );
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };
  const PageName = "Connection Center";
  const submit = async (closeAction: string) => {
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName,
      });
    handleFormSubmission(executeOperationFunction, {
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: setAllFieldsData,
      onSuccess: () => { },
      onError: (error: any) => {
        ErrorToast((error as Error).message);
      },
    });
  };

  // eslint-disable-next-line
  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleKeyDownf3 = useCallback(
    (event) => {
      event.stopPropagation();
      if (event.keyCode === 27) {
        return Closeformfunction();
      }
    },
    [Closeformfunction]
  );
  useKeyDown(HandleKeyDownf3);
  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
      //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={ConnectionCenterLoading}
        />
      </Reactportal>
    );
  }
  return (
    <>
      <div>
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " " + "Connection Center"}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
        >
          <>
            <div className="formContainer">
              {ConnectionCenterFields.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        accountId=""
                        inputfields={e.fields}
                        Type={e.name}
                        fielddata={allFieldsData}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
            <PortalFooter
              disabled={false}
              submitform={submit}
              submitType={submitType}
              SaveAndClose={TypeOfPortal === "Add" ? SaveAndCloseForAdd : submit}
              handleformclose={() => {
                Closeformfunction();
                settoggle(!toggle);
              }}
              loadingState={ConnectionCenterLoading}
            />
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddConnectionCenter;
